import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EditionContractPublisherView } from "./EditionContractPublisherView";
import { EditionContractPublisherViewStore } from "../../store/EditionContractPublisherViewStore";
import { useStore } from "../../../../hooks";

export const EditionContractPublisherViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/editionContractPublisher/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EditionContractPublisherViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EditionContractPublisherView
          editionContractPublisherViewStore={store}
        />
      </PageLayout>
    </div>
  );
});
